<div class="space-y-4" *ngIf="datos">
  <div class="flex flex-wrap items-center gap-2">
    <span class="kb-badge kb-badge-contorno">{{ TIPOS[datos.tipo] || datos.tipo }}</span>
    <span class="kb-badge kb-badge-alerta" *ngIf="datos.noSe"><i class="fas fa-question-circle" aria-hidden="true"></i>No supo contestar</span>
  </div>

  <p class="m-0 whitespace-pre-wrap text-sm leading-relaxed text-foreground">{{ datos.respuesta }}</p>

  <!-- La tabla que respalda la respuesta. -->
  <div class="rounded-lg border border-border bg-card" *ngIf="datos.tabla && datos.tabla.columnas?.length">
    <div class="flex flex-wrap items-center justify-between gap-2 border-b border-border px-4 py-2">
      <p class="m-0 text-xs text-muted-foreground">{{ datos.tabla.titulo }}</p>
      <p class="m-0 text-xs tabular-nums text-muted-foreground">{{ nf(datos.tabla.filas.length) }} {{ datos.tabla.filas.length === 1 ? 'fila' : 'filas' }}</p>
    </div>
    <p class="m-0 border-b border-border px-4 py-1.5 text-xs kb-texto-alerta" *ngIf="datos.tabla.truncado">
      La consulta devolvió más de lo que entra: esto es un recorte, no el total.
    </p>
    <div class="max-h-80 overflow-auto">
      <table class="kb-table">
        <thead class="kb-thead">
          <tr>
            <th class="kb-th" *ngFor="let c of datos.tabla.columnas; let i = index" [class.kb-th-num]="numerica(i)">{{ c }}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="kb-tr" *ngFor="let f of datos.tabla.filas">
            <td class="kb-td" *ngFor="let v of f; let j = index" [class.kb-td-num]="numerica(j)">
              <span class="text-muted-foreground" *ngIf="v === null">—</span>
              <ng-container *ngIf="v !== null">{{ celda(v, formato(j)) }}</ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Lo que le falta al comercio, si la pregunta fue por su ficha. -->
  <ul class="m-0 grid list-none gap-2 p-0 sm:grid-cols-2" *ngIf="datos.pendientes?.length">
    <li class="!my-0 flex items-center justify-between gap-3 rounded-md border border-border px-3 py-2 text-sm"
        *ngFor="let p of datos.pendientes">
      <span class="min-w-0">
        {{ p.que }}
        <span class="block text-xs text-muted-foreground font-mono" *ngIf="p.donde">{{ p.donde }}</span>
      </span>
      <span class="kb-badge shrink-0" [ngClass]="PENDIENTE[p.estado]?.clase || 'kb-badge-neutro'">
        <i class="fas" [ngClass]="PENDIENTE[p.estado]?.icono || 'fa-minus-circle'" aria-hidden="true"></i>{{ PENDIENTE[p.estado]?.texto || p.estado }}
      </span>
    </li>
  </ul>

  <div class="flex flex-col gap-3 text-sm sm:flex-row sm:flex-wrap sm:gap-x-8"
       *ngIf="datos.fichas?.length || datos.enlaces?.length">
    <div *ngIf="datos.fichas?.length">
      <p class="m-0 mb-1 text-xs text-muted-foreground">Fichas que usó</p>
      <ul class="m-0 list-none space-y-0.5 p-0">
        <li class="!my-0" *ngFor="let f of datos.fichas"><i class="fas fa-file-alt mr-1.5 text-muted-foreground" aria-hidden="true"></i>{{ f.titulo }} <span class="font-mono text-xs text-muted-foreground">{{ f.id }}</span></li>
      </ul>
    </div>
    <div *ngIf="datos.enlaces?.length">
      <p class="m-0 mb-1 text-xs text-muted-foreground">Pantallas del portal que ofrece</p>
      <ul class="m-0 list-none space-y-0.5 p-0">
        <li class="!my-0" *ngFor="let e of datos.enlaces"><i class="fas fa-external-link-alt mr-1.5 text-muted-foreground" aria-hidden="true"></i>{{ e.label }} <span class="font-mono text-xs text-muted-foreground">{{ e.destino }}</span></li>
      </ul>
    </div>
  </div>

  <div class="flex flex-wrap gap-1.5" *ngIf="datos.sugerencias?.length">
    <button type="button" class="kb-chip" *ngFor="let s of datos.sugerencias" (click)="preguntar.emit(s)">{{ s }}</button>
  </div>

  <p class="m-0 flex flex-wrap gap-x-4 gap-y-1 border-t border-border pt-3 text-xs text-muted-foreground">
    <span>Modelo: <span class="font-mono text-foreground">{{ datos.modeloId || 'ninguno (sin modelo)' }}</span></span>
    <span>Costo: <span class="tabular-nums text-foreground">{{ usd(datos.costoUsd) }}</span></span>
    <span *ngIf="datos.traceId">Identificador: <span class="font-mono">{{ datos.traceId }}</span></span>
  </p>
</div>
